import {Component} from "preact"
import ToolbarButton from "../../../../../common/toolbar-button";
import ConfigService from "../../../../../../services/ConfigService";
import {OutsideClickWrapper} from "../../../../../layout/outside-click-wrapper";
import DropDownMenu from "../../../../../common/dropdown";
import {translate} from "../../../../../../services/TranslateService";
import SectionComponent from "../../../../../layout/section-component";
import {createEvent} from "../../../../../../utilities/create-event";
import HelpCircleOutlineIcon from "mdi-preact/HelpCircleOutlineIcon";
import HelpDeskMain from "../help-desk-main";

export default class HelpDeskButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }


    render(props, state, context) {
        const hasManuals = Array.isArray(ConfigService.manuals()) && ConfigService.manuals().length;
        const hasHelpdeskUrl = ConfigService.helpdeskUrl() && ConfigService.helpdeskUrl().length;

        if (!hasManuals && !hasHelpdeskUrl) return null;
        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};

        return (
            <OutsideClickWrapper watch={this.state.open} onOutsideClick={this.toggleDropdown}>
                <SectionComponent>
                    <ToolbarButton onClick={this.toggleDropdown} title={translate('help_desk_dropdown_title')} style={buttonStyles}>
                        <HelpCircleOutlineIcon/>
                    </ToolbarButton>
                    <DropDownMenu open={this.state.open}>
                        <HelpDeskMain/>
                    </DropDownMenu>
                </SectionComponent>
            </OutsideClickWrapper>
        );
    }

    navigateToManual = (url) => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        ConfigService.navigateFunction(url);
    };

    toggleDropdown = () => {
        this.setState({open: !this.state.open});
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/help-desk/help-desk-button/index.js